"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fNaN = void 0;
exports.fNaN = {
    "": [
        2470,
        5824,
        6295,
        6805,
        6806,
        2764,
        2765,
        2766,
        5834,
        6234
    ]
};
